/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {createCustomTheme} from '@ion/dls/src/theme/theme';
// @ts-ignore
import json from './theme.json5';

/**
 * Generates the ADM custom theme which extends the default iOn DLS theme.
 */
export default createCustomTheme(json);
